/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
// import { Redirect } from 'react-router-dom'
import Logo from "./../../../assets/Jobvious_logo.png";
import { SignIn } from "aws-amplify-react";
import { Auth } from "aws-amplify";
import { HTTPService } from "../../../services/httpService";

const API = new HTTPService();

export class Login extends SignIn {
  constructor(props) {
    super(props);
    this._validAuthStates = ["signIn", "signOut"];
  }

  processLogin() {
    //console.log("Starting processLogin");

    const username = this.getUsernameFromInput() || '';
    const password = this.inputs.password;

    Auth.signIn(username, password).then((user) => {
      //console.log("SignIn response:", user);

      // Check if user needs to change password
      if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        //console.log("User needs new password, changing state");
        this.changeState('requireNewPassword', user);
        return;
      }

      // Check for other challenges
      if (user.challengeName === 'SMS_MFA' || user.challengeName === 'SOFTWARE_TOKEN_MFA') {
        this.changeState('confirmSignIn', user);
        return;
      }

      if (user.challengeName === 'MFA_SETUP') {
        this.changeState('TOTPSetup', user);
        return;
      }

      // User is fully authenticated, proceed with login process
      //console.log("User authenticated, extracting user details");

      if (user) {
        try {
          const userType = user.signInUserSession.accessToken.payload["cognito:groups"][0];
          //console.log("User type:", userType);
            
            // Channel data available in localStorage if needed:
            // localStorage.getItem("X3VhX3NkazoxejB6ckxKNVJKLXNid3N0NG9VbGZROi9wdXNoLXdvcmtlci5qcw==:channel")

            //console.log("Making API call to /auth/login/ with email:", user.attributes.email);
            // Add this console log in your login function
            
            API.get(`/auth/login/?email=${user.attributes.email}`)
              .then((response) => {
                //console.log("API call successful:", response);
                
                const user = response.data;
                localStorage.setItem("userAPI", JSON.stringify(user));

                if (userType === "Dealer") {
                  //console.log("Processing Dealer user, Company_id:", user.Company_id);

                  // Fetch dealer company data and check for dealer_group association in parallel
                  Promise.all([
                    API.get(`/dealers/${user.Company_id}`),
                    API.get(`/user-companies/${user.User_id}`).catch(() => ({ data: [] }))
                  ])
                    .then(([dealerResponse, userCompaniesResponse]) => {
                      // Company dealer
                      const company = dealerResponse.data;
                      const companyName = company[0].dealer_name
                        .replace(/ /g, "_")
                        .toLowerCase();
                      localStorage.setItem(
                        "companyAPI",
                        JSON.stringify(company[0])
                      );
                      localStorage.setItem(
                        "named_user_id",
                        JSON.stringify(companyName)
                      );

                      // Check if user is associated with a dealer_group
                      const userCompanies = userCompaniesResponse.data || [];
                      const dealerGroupAssoc = userCompanies.find(
                        uc => uc.company_type === 'dealer_group'
                      );

                      if (dealerGroupAssoc) {
                        localStorage.setItem(
                          "dealerGroupAPI",
                          JSON.stringify({
                            isDealerGroup: true,
                            groupId: dealerGroupAssoc.company_id,
                            groupName: dealerGroupAssoc.company_name || dealerGroupAssoc.name || ''
                          })
                        );
                        window.location = "/financials";
                      } else {
                        window.location = "/requestimates";
                      }
                    })
                    .catch((err) => {
                      console.error("Dealer API error:", err);
                      console.error("Error details:", {
                        message: err.message,
                        response: err.response,
                        status: err.response ? err.response.status : 'No response',
                        data: err.response ? err.response.data : 'No response data'
                      });
                      // Handle dealer API error
                      alert("Error loading dealer information. Please try again.");
                    });
                } else {
                  //console.log("Processing Installer user, Company_id:", user.Company_id);
                  
                  API.get(`/installers/${user.Company_id}`)
                    .then((response) => {
                      //console.log("Installer API call successful:", response);
                      
                      // Company installer
                      const company = response.data;
                      const companyName = company[0].Installer_Name.replace(
                        / /g,
                        "_"
                      ).toLowerCase();
                      localStorage.setItem(
                        "companyAPI",
                        JSON.stringify(company[0])
                      );
                      localStorage.setItem(
                        "named_user_id",
                        JSON.stringify(companyName)
                      );
                      
                      //console.log("Redirecting to /requestimates");
                      window.location = "/requestimates";
                    })
                    .catch((err) => {
                      console.error("Installer API error:", err);
                      console.error("Error details:", {
                        message: err.message,
                        response: err.response,
                        status: err.response ? err.response.status : 'No response',
                        data: err.response ? err.response.data : 'No response data'
                      });
                      // Handle installer API error
                      alert("Error loading installer information. Please try again.");
                    });
                }
              })
              .catch((err) => {
                console.error("Login API error:", err);
                console.error("Full error object:", err);
                console.error("Error details:", {
                  message: err.message,
                  response: err.response,
                  status: err.response ? err.response.status : 'No response',
                  data: err.response ? err.response.data : 'No response data',
                  config: err.config ? err.config : 'No config'
                });
                
                // Show user-friendly error message
                alert("Login failed. Please check your connection and try again.");
              });

        } catch (error) {
          console.error("Error processing user details:", error);
          alert("Error processing login. Please try again.");
        }

        // return <Redirect to={ { path: '/requestimates', state: { company: 'teste' } } } />;
      } else {
        console.error("No authenticated user found after login");
        alert("Authentication failed. Please try again.");
      }
    }).catch((signInErr) => {
      console.error("SignIn failed:", signInErr);
      console.error("SignIn error details:", {
        message: signInErr.message,
        code: signInErr.code,
        name: signInErr.name
      });

      // Don't show alert for UserNotConfirmedException - let the component handle it
      if (signInErr.code === 'UserNotConfirmedException') {
        this.changeState('confirmSignUp', { username: this.getUsernameFromInput() });
      } else if (signInErr.code === 'PasswordResetRequiredException') {
        this.changeState('forgotPassword', { username: this.getUsernameFromInput() });
      } else {
        // Show generic error for other cases
        alert("Sign in failed. Please check your credentials and try again.");
      }
    });
  }

  signIn() {
    //console.log("Starting signIn process");
    localStorage.clear();
    
    const UA = window.UA;
    
    if (UA) {
      //console.log("UA found, attempting to register");
      UA.then((sdk) => {
        sdk
          .register()
          .then(() => {
            //console.log("UA registration successful, proceeding with login");
            this.processLogin();
          })
          .catch((error) => {
            //console.log("UA registration failed, proceeding with login anyway:", error);
            // alert("Your browser does not support Airship notifications.");
            this.processLogin();
          });
      }).catch((error) => {
        //console.log("UA promise failed, proceeding with login anyway:", error);
        // alert("Your browser does not support Airship notifications.");
        this.processLogin();
      });
    } else {
      //console.log("No UA found, proceeding with login");
      this.processLogin();
    }
  }

  showComponent(theme) {
    return (
      <div className="App">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="content p-5">
                <div className="row justify-content-md-center">
                  <div className="card col-lg-4 p5-lg">
                    <div className="card-body">
                      <h5 className="card-title text-center mb-5">
                        <img src={Logo} alt="" />
                      </h5>
                      <h6 className="card-subtitle mb-2 text-muted text-center">
                        Sign in to Jobvious
                      </h6>
                      {/* Form */}
                      <form>
                        <div className="form-group">
                          <label className="font-bold" htmlFor="username">
                            Email
                          </label>
                          <input
                            className="form-control"
                            id="username"
                            key="username"
                            name="username"
                            onChange={this.handleInputChange}
                            type="text"
                          />
                        </div>
                        <div className="form-group">
                          <label className="font-bold" htmlFor="password">
                            Password
                          </label>
                          <input
                            className="form-control"
                            id="password"
                            key="password"
                            name="password"
                            onChange={this.handleInputChange}
                            type="password"
                            autoComplete="off"
                          />
                          <small className="form-text text-muted mt-2">
                            Forgot your password?{" "}
                            <a
                              href="#"
                              onClick={() =>
                                super.changeState("forgotPassword")
                              }
                              style={{ textDecoration: "underline" }}
                            >
                              Reset Password
                            </a>
                          </small>
                        </div>
                        <div className="form-group">
                          <button
                            className="btn btn-outline-primary btn-block mb-3"
                            type="button"
                            onClick={() => this.signIn()}
                          >
                            Lets Go
                          </button>
                        </div>
                      </form>
                      {/* End Form */}
                      {/* Divider */}
                      <hr />

                      {/* New to Jobvious */}
                      <div className="text-center mt-4">
                        <h6>New to Jobvious?</h6>
                        <p>Not sure if you have a login yet?</p>
                        <a
                          className="btn btn-outline-secondary"
                          href="https://www.jobvious.com"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Visit our Homepage
                        </a>
                      </div>

                      {/* Need help logging in */}
                      <div className="text-center mt-3">
                        <p>
                          Need help logging in?{" "}
                          <a href="mailto:support@jobvious.com?subject=Login%20Assistance&body=Hi%20Jobvious%20Support%2C%0A%0AI%20need%20help%20with%20logging%20in.%20My%20email%20is%3A%20%5Benter%20your%20email%20here%5D.%0A%0AThanks!">
                            Contact Support
                          </a> 
                        </p>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col text-center">
                  <p>&copy; 2025 Jobvious, Inc </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
// export default withRouter(Login);